import * as React from 'react';

import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ActionButton from '../../../../components/ActionButton.js';
import { AutoStopAllRecording } from '../../../../slices/userRecordingSlice';
import CancelButton from '../../../../components/CancelButton';
import { ErrorNotificationMessage, } from '../../../../content/shared/NotificationMessage';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HeaderUserbox from '../Userbox/index'
import Logout from '@mui/icons-material/Logout';
import { deleteSession } from '../../../../slices/userSessionSlice';
import { recordingState } from '../../../../slices/recordingSlice';
import useAuth from '../../../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loginLink } from 'src/router/routerLink.js';

export default function ProfileMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const { recordings } = useSelector(recordingState);
  const open = Boolean(anchorEl);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = async () => {
    recordings.length != 0 ? setOpenDialog(true) : handleLogout();
  };
  const handleLogout = async () => {
    dispatch(deleteSession()).unwrap()
      .then(async () => {
        await logout();
        console.log("Logged out");

        sessionStorage.removeItem("SettingProfile");
        console.log("SettingProfile remove");

        navigate(loginLink);
        handleClose();
      });
  }
  const handleSaveAndLogout = async () => {
    try {
      dispatch(AutoStopAllRecording())
        .unwrap()
        .then(async () => {
          handleLogout();
        })
        .catch((err) => {
          ErrorNotificationMessage(dispatch, err.message != "Error" ? err.message : "You are not allowed to stop this record.");
          setOpenDialog(false)
        })
    } catch (err) {
      ErrorNotificationMessage(dispatch, err.message);
    }
  }
  const handleCloseDialog = () => { setOpenDialog(false) }

  return (
    <div>
      <Dialog open={openDialog}
        PaperProps={{ sx: { width: '279px', height: '174px', background: '#2C314C' } }}
      >
        <DialogTitle sx={{ letterSpacing: '0.16px', fontFamily: 'Lato', fontWeight: 700, fontSize: '14px', lineHeight: '18px', color: '#E6E7EB' }}>
          <Typography style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <ErrorOutlineIcon style={{ color: '#FFE17C', fontSize: 'large' }} />&nbsp; Recording in progress
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              width: '225px',
              height: '32px',
              fontSize: '12px',
              fontFamily: 'Lato',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '16px',
              letterSpacing: '0.32px',
              alignContent: 'center',
              display: 'flex',
              color: '#E6E7EB'
            }}
          >
            If you logout now, your Recording will be stopped and saved. The saved Recording can be found in the Recorded Video tab.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ marginRight: '15px' }}>
          <ActionButton
            label='Save and Logout'
            handleClick={handleSaveAndLogout}
            buttonStyle={{ width: '120px', marginLeft: '5px' }}
            fontSize={{ width: '92px' }} />
          <CancelButton
            handleClick={handleCloseDialog}
            label='Cancel'
            disable={false}
            buttonStyle={{ width: '100px', marginLeft: '5px' }} />
        </DialogActions>
      </Dialog>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="medium"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <AccountCircleOutlinedIcon size="medium" />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        id="basic-menu"
        keepMounted
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            backgroundColor: '#000000',
            borderRadius: 0,
          }
        }}

      >
        <MenuItem  >
          <HeaderUserbox />
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleOpenDialog}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t("Logout")}
        </MenuItem>
      </Menu>

    </div>
  );
}
